/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransformStepDto
 */
export interface TransformStepDto {
    /**
     * 
     * @type {string}
     * @memberof TransformStepDto
     */
    type: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransformStepDto
     */
    order?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof TransformStepDto
     */
    options?: { [key: string]: string; } | null;
}

/**
 * Check if a given object implements the TransformStepDto interface.
 */
export function instanceOfTransformStepDto(value: object): value is TransformStepDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function TransformStepDtoFromJSON(json: any): TransformStepDto {
    return TransformStepDtoFromJSONTyped(json, false);
}

export function TransformStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransformStepDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'order': json['order'] == null ? undefined : json['order'],
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function TransformStepDtoToJSON(json: any): TransformStepDto {
    return TransformStepDtoToJSONTyped(json, false);
}

export function TransformStepDtoToJSONTyped(value?: TransformStepDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'order': value['order'],
        'options': value['options'],
    };
}

